<template>
  <div id="boost">
    <b-row>
      <b-col md="8">
        <DefaultLayout>
          <div class="action-buttons">
            <AddContentButton color="#93014A" @click="onClickAddBoosts"
              >CREATE BOOST</AddContentButton
            >
          </div>
          <div class="content pt-10">
            <BoostContent></BoostContent>
          </div>
          <transition name="fade">
            <BoostsForm v-if="showBoostsForm" @close="onCloseBoost" />
          </transition>
        </DefaultLayout>
      </b-col>
      <b-col md="4">
        <perfect-scrollbar class="col-md-12">
          <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-body px-2">
              <h5 class="card-title font-weight-bold">Promotions Options</h5>
              <div class="card-text">
                <div class="row form-group">
                  <div class="col-md-6 px-1">
                    <button
                      class="
                        btn btn-secondary btn-block btn-sm
                        sizefont-12
                        action-button
                      "
                      @click="setSelectedMoment('rejected')"
                      :disabled="!hasSelectedMoments"
                    >
                      <img :src="icons.rejected" class="icon icon-pending" />
                      <span>HOLD PROMOTION</span>
                    </button>
                  </div>
                  <div class="col-md-6 px-1">
                    <button
                      class="
                        btn btn-secondary btn-block btn-sm
                        sizefont-12
                        action-button
                      "
                      @click="setSelectedMoment('approved')"
                      :disabled="!hasSelectedMoments"
                    >
                      <img :src="icons.published" class="icon icon-approved" />
                      <span>RESTART PROMO</span>
                    </button>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-12 px-0">
                    <button
                      class="btn btn-add-content btn-block"
                      @click="$emit('showVisualForm')"
                    >
                      ADD BOOST
                    </button>
                  </div>
                  <div class="col-md-12 px-0">
                    <button
                      class="btn btn-add-content btn-block"
                      @click="$emit('showVisualForm')"
                    >
                      ADD ADVERTISE
                    </button>
                  </div>
                  <div class="col-md-12 px-0">
                    <button
                      class="btn btn-add-content btn-block"
                      @click="$emit('showVisualForm')"
                    >
                      ADD MESSAGE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow p-3 mb-5 bg-white rounded filters-form">
            <div class="card-body px-2">
              <h5 class="card-title font-weight-bold">Filter Content</h5>
              <form @submit.prevent="onSubmitSearch">
                <div class="card-text">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search content"
                        v-model="searchFilters.search"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active:
                            searchFilters.statuses.indexOf('Running') > -1,
                        }"
                        @click="toggleSelectedStatus('Running')"
                      >
                        Running
                      </a>
                    </div>
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active: searchFilters.statuses.indexOf('hold') > -1,
                        }"
                        @click="toggleSelectedStatus('hold')"
                      >
                        On hold
                      </a>
                    </div>
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active:
                            searchFilters.statuses.indexOf('Completed') > -1,
                        }"
                        @click="toggleSelectedStatus('Completed')"
                      >
                        Completed
                      </a>
                    </div>
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active: searchFilters.statuses.indexOf('Boosts') > -1,
                        }"
                        @click="toggleSelectedStatus('Boosts')"
                      >
                        Boosts
                      </a>
                    </div>
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active:
                            searchFilters.statuses.indexOf('Advertisements') >
                            -1,
                        }"
                        @click="toggleSelectedStatus('Advertisements')"
                      >
                        Advertisements
                      </a>
                    </div>
                    <div class="col-md-4 px-1">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-filter btn-block sizefont-12"
                        :class="{
                          active:
                            searchFilters.statuses.indexOf('Messages') > -1,
                        }"
                        @click="toggleSelectedStatus('Messages')"
                      >
                        Messages
                      </a>
                    </div>
                  </div>
                  <div class="form-group">
                    <select class="form-control" v-model="searchFilters.sortBy">
                      <option
                        v-for="option of sortOptions"
                        :key="option.key"
                        :value="option.key"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="form-group"
                    v-if="availableHashtags && availableHashtags.length > 0"
                  >
                    <select
                      class="form-control"
                      @change="onDropDownHashtagChange"
                    >
                      <option value>All my listings</option>
                      <option
                        v-for="(hashtag, index) of availableHashtags"
                        :key="index"
                        :value="hashtag"
                      >
                        {{ hashtag }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <ul class="list-hashtag">
                      <li
                        v-for="(tag, index) of searchFilters.tags"
                        :key="index"
                      >
                        {{ tag }}
                        <i
                          class="fas fa-times ml-3"
                          @click="onClickDeleteHashtag(tag)"
                        ></i>
                      </li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <select class="form-control">
                      <option value>Sort by name</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <a href="#" class="btn-reset" @click="resetSelectedHashtag"
                      >reset</a
                    >
                  </div>
                  <div class="form-group">
                    <select class="form-control">
                      <option value>All Channels</option>
                    </select>
                  </div>
                  <div class="form-actions row">
                    <div class="col-md-6">
                      <button class="btn btn-primary btn-block" type="submit">
                        <span>APPLY</span>
                        <img :src="icons.approved" />
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button
                        class="btn btn-secondary btn-block"
                        type="reset"
                        @click="onResetSearch"
                      >
                        <span>RESET FILTERS</span>
                        <img :src="icons.reset" />
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </perfect-scrollbar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import AddContentButton from "@/components/AddContentButton";
import BoostsForm from "@/components/Promotor/BoostsForm";
import BoostContent from "@/components/Promotor/BoostsContent.vue";
import iconReject from "@/assets/images/icons/ew-icon_hidden.svg";
import iconPublished from "@/assets/images/icons/ew-icon_published.svg";
import iconApproved from "@/assets/images/icons/ew-icon_approved.svg";
import iconReset from "@/assets/images/icons/ew-icon_reset.svg";
import iconPending from "@/assets/images/icons/ew-icon_undecided.svg";
import download from "@/assets/images/icons/ew-icon_download.svg";
import loader from "@/assets/images/loader.svg";
import Pagination from "@/components/Pagination";
import Loader from "@/components/Loader";

export default {
  components: {
    DefaultLayout,
    AddContentButton,
    BoostsForm,
    BoostContent,
  },
  data() {
    return {
      showBoostsForm: false,
      content: null,
      emptyText:
        "This account has no Boost yet. Please press the ADD button above",
        icons: {
        rejected: iconReject,
        published: iconPublished,
        pending: iconPending,
        approved: iconApproved,
        reset: iconReset,
        loader,
        download,
      },
      items: [
        {
          name: "Experience 1 Booster",
          type: "Boost",
          distribution: ["mekong Moments", "Inspiring Laos"],
          duration: "11:12:2021 11:00",
          status: "completed",
        },
      ],
      selectedMoments: [],
      availableHashtags: [],
      searchFilters: {
        search: "",
        tags: [],
        onlyShowUserContents: false,
        statuses: [],
        sortBy: "CREATED_AT",
        sortAscending: false,
      },
      sortOptions: [
        {
          key: "CREATED_AT",
          value: "Sort by post created date",
        },
        {
          key: "LIKE_COUNT",
          value: "Sort by post most liked",
        },
      ],
    };
  },
  methods: {
    onCloseBoost() {
      this.showBoostsForm = false;
    },
    onClickAddBoosts() {
      this.showBoostsForm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button {
  img {
    height: 25px;
    margin-right: 5px;
    vertical-align: middle;
  }
}
.filters-form {
  width: 100%;
  .form-control,
  .form-control-label {
    font-size: 12px;
  }
  .btn {
    img {
      width: 20px;
      vertical-align: middle;
      float: right;
    }
  }

  .btn-filter {
    background-color: #58595b;
    color: white;
    border-radius: 15px;
    & + .btn-filter {
      margin-left: 10px;
    }
    &.active {
      background-color: var(--color-promotor);
      border-color: var(--color-promotor);
    }
  }
}

@media only screen and (min-width: 768px) {
  .paging-mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .ps {
    height: 50vh;
  }
  .paging {
    display: none;
    margin: 0 auto;
  }
  .paging-mobile {
    margin: 5px auto;
  }
}
</style>